import { reactQueryConfig } from "../config/reactQueryConfig";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';


const queryClient = new QueryClient(reactQueryConfig);

export const ReactQueryProvider = ({ children }) => {
   
    const showDevTools = process.env.REACT_APP_INNO_ENV === 'development';
    
    return (
    <QueryClientProvider client={queryClient}>
        {children}
        {showDevTools && (
          <ReactQueryDevtools 
            initialIsOpen={false}
            position="bottom"
            buttonPosition="bottom-left"
          />
        )}
    </QueryClientProvider>);
};

export { queryClient }